import GroupService from '@/api/services/GroupService';
import { LINK_TYPE } from '@/constants/link';

const retrieveGroups = ({ commit }) => {
  const groups = [
    GroupService.getUserGroups(),
    GroupService.getEnterpriseGroups()
  ]

  return Promise.all(groups).then(([currentUserGroups, enterpriseGroups]) => {
    commit('setCurrentUserGroups', currentUserGroups);
    commit('setEnterpriseGroups', enterpriseGroups);
  }, GroupService.onApiError);
};

const addUserGroup = ({ commit, rootGetters }, group) => {
  group.linkId = rootGetters['user/userLinkId'];
  group.linkType = LINK_TYPE.user;

  return GroupService.upsertUserGroup(group).then(storedGroup => {
    commit('addUserGroup', storedGroup);
    return storedGroup;
  }, GroupService.onApiError);
}

const editUserGroup = ({ commit, rootGetters }, group) => {
  group.linkId = rootGetters['user/userLinkId'];
  group.linkType = LINK_TYPE.user;

  return GroupService.upsertUserGroup(group).then(storedGroup => {
    commit('editUserGroup', storedGroup);
    return storedGroup;
  }, GroupService.onApiError);
}

const deleteUserGroup = ({ commit }, groupId) => {
  return GroupService.deleteUserGroup(groupId).then(() => {
    commit('deleteUserGroup', groupId);
  }, GroupService.onApiError);
}

const removeContactFromAllGroups = ({ commit }, contact) => {
  commit('removeContactFromAllGroups', contact);
}

const removeContactFromGroup = ({ commit }, { contact, group }) => {
  GroupService.removeContactFromUserGroup(group.id, contact.id).then(storedGroup => {
    commit('editUserGroup', storedGroup);
  });
}

export default {
  addUserGroup,
  editUserGroup,
  deleteUserGroup,
  retrieveGroups,
  removeContactFromAllGroups,
  removeContactFromGroup
};
